import { Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap'
import statesList from '../../../util/statesList'

export default function EditProfile({ clinicianProfile, basicValidation, isPersonInfoWip, setIsPersonInfoWip, handleClear, setProfileDetails }) {
  return (
    <Col>
      <Form id="newForm" style={{ height: '100%' }} onSubmit={basicValidation} onChange={() => setIsPersonInfoWip(true)}>
        <Col
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            paddingBottom: 30,
          }}
        >
          <p
            style={{
              fontSize: 28,
              color: 'rgba(0, 127, 97, 1)',
              textTransform: 'capitalize',
              fontFamily: 'GT Super Display',
              fontWeight: '500',
              marginTop: 60,
              width: '100%',
              textAlign: 'left',
            }}
          >
            General Details
          </p>
          <Row style={spaceOut}>
            <Col md="3">
              <Form.Group className="mb-3" controlId="firstName">
                <Form.Label style={bold}>First Name</Form.Label>
                <Form.Control defaultValue={clinicianProfile?.firstName || null} required name="firstName" type="text" placeholder="First Name" />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group className="mb-3" controlId="middleName">
                <label style={bold}>Middle Name</label>
                <Form.Control defaultValue={clinicianProfile?.middleName || ''} name="middleName" placeholder="Middle Name" type="text" />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group className="mb-3" controlId="lastName">
                <label style={bold}>Last Name</label>
                <Form.Control defaultValue={clinicianProfile?.lastName || null} required name="lastName" placeholder="Last Name" type="text" />
              </Form.Group>
            </Col>
          </Row>
          <Row style={spaceOut}>
            <Col md="3">
              <Form.Group className="mb-3" controlId="dob">
                <label style={bold}>Date of Birth</label>
                <Form.Control defaultValue={clinicianProfile?.dob || null} required name="dob" placeholder="DOB" type="date" />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group className="mb-3" controlId="v">
                <label style={bold}>Fun Fact</label>
                <Form.Control defaultValue={clinicianProfile?.funFact || null} name="funFact" as={'textarea'} placeholder="Fun Facts" type="text" />
              </Form.Group>
            </Col>
            <Col md="3"></Col>
          </Row>
          <p
            style={{
              fontSize: 28,
              color: 'rgba(0, 127, 97, 1)',
              textTransform: 'capitalize',
              fontFamily: 'GT Super Display',
              fontWeight: '500',
              width: '100%',
              textAlign: 'left',
            }}
          >
            Contact Details
          </p>
          <Row style={spaceOut}>
            <Col md="3">
              <Form.Group className="mb-3" controlId="personalEmail">
                <label style={bold}>Personal Email</label>
                <Form.Control defaultValue={clinicianProfile?.personalEmail || null} required name="personalEmail" placeholder="Personal Email" type="email" />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group className="mb-3" controlId="address1">
                <label style={bold}>Address Line 1</label>
                <Form.Control defaultValue={clinicianProfile?.address1 || null} required name="address1" placeholder="Address Line 1" type="text" />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group className="mb-3" controlId="address2">
                <label style={bold}>Address Line 2</label>
                <Form.Control defaultValue={clinicianProfile?.address2 || null} required name="address2" placeholder="Address Line 2" type="text" />
              </Form.Group>
            </Col>
          </Row>
          <Row style={spaceOut}>
            <Col md="3">
              <Form.Group className="mb-3" controlId="city">
                <label style={bold}>City</label>
                <Form.Control defaultValue={clinicianProfile?.city || null} required name="city" placeholder="City" type="text" />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group className="mb-3" controlId="state">
                <label style={bold}>State</label>
                <Form.Select defaultValue={clinicianProfile?.state || null}                
                  style={{ width: "100%" }} required name="state" id="formSelect">
                  <option disabled value="">
                    Select State
                  </option>
                  {statesList?.map(item => (
                    <option value={item.value} selected={clinicianProfile?.state === item.value ? true : false}>{item.value}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group className="mb-3" controlId="zip">
                <label style={bold}>Zip Code</label>
                <Form.Control defaultValue={clinicianProfile?.zip || null} required name="zip" placeholder="Zip Code" type="text" />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-4 ml-2" style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
            <Button
              variant="light"
              style={{
                width: 180,
                height: 40,
                borderRadius: 8,
                backgroundColor: 'rgba(253, 250, 241, 1)',
                fontSize: 20,
                fontWeight: '500',
                lineHeight: '100%',
                border: 'none',
                color: 'rgba(0, 127, 97, 1)',
              }}
              onClick={handleClear}
            >
              Clear
            </Button>
            <Button
              variant="light"
              type="submit"
              style={{
                width: 180,
                height: 40,
                marginLeft: 20,
                borderRadius: 8,
                backgroundColor: 'rgba(0, 127, 97, 1)',
                fontSize: 20,
                fontWeight: '500',
                lineHeight: '100%',
                color: 'rgba(253, 250, 241, 1)',
                border: 'none',
              }}
            >
              Update
            </Button>

            {isPersonInfoWip === true && (
              <Button
                variant="light"
                onClick={() => {
                  setProfileDetails(null)
                  setIsPersonInfoWip(false)
                }}
                style={{
                  width: 'auto',
                  paddingInline: 20,
                  height: 40,
                  marginLeft: 20,
                  borderRadius: 8,
                  backgroundColor: 'red',
                  fontSize: 20,
                  fontWeight: '600',
                  lineHeight: '100%',
                  color: 'rgba(253, 250, 241, 1)',
                  border: 'none',
                  marginRight: 40,
                  letterSpacing: 1.5,
                }}
              >
                X &nbsp;&nbsp;Discard
              </Button>
            )}
          </Row>
        </Col>
      </Form>
    </Col>
  )
}

const spaceOut = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}

const bold = {
  fontWeight: 'bold',
}
